import { AJOUTE_SOCIETE, SUPRIMER_SOCIETE } from '../types/typeSociete';
const societe = [];
const SocieteReducer = (state = societe, action) => {
    if (localStorage.getItem('societe')) {
        state = JSON.parse(localStorage.getItem('societe'));
    }
    switch (action.type) {
        case AJOUTE_SOCIETE:
            state = action.payload;
            return state;
            break;
        case SUPRIMER_SOCIETE:
            return state = [];
        default:
            return state;

    }
}

export default SocieteReducer;